import { API_POST } from "../../services/api.service";

export const getCampaignData = async (admin) => {
  const registerRequest = await API_POST("action/getdata", {
    root: "campaigns",
    con: { admin: admin, IsActive: true },
  });

  if (registerRequest && registerRequest.status == 200) {
    if (registerRequest.data.length > 0) {
      return registerRequest.data;
    }
  }
  return [];
};



